import { render } from "./BookingsCard.vue?vue&type=template&id=8c230e8a"
import script from "./BookingsCard.vue?vue&type=script&lang=js"
export * from "./BookingsCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QExpansionItem,QCardSection,QIcon,QTooltip,QBadge});
